import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Protected } from "./components/Protected";
import { LoginPage } from "./features/auth/LoginPage";
import { TotpPage } from "./features/auth/TotpPage";
import { ClientsPage } from "./features/clients/ClientsPage";
import { OpportunitiesPage } from "./features/opportunities/OpportunitiesPage";
import { PricesPage } from "./features/prices/PricesPage";
import { ImportPage } from "./features/prices/ImportPage";
import { ProspectsPage } from "./features/prospects/ProspectsPage";
import { SecuritiesPage } from "./features/securities/SecuritiesPage";
import { SgisPage } from "./features/sgis/SgisPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/securities" replace />} />
        <Route path="/securities" element={<SecuritiesPage />} />
        <Route path="/sgis" element={<SgisPage />} />
        <Route path="/prices" element={<PricesPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/prospects" element={<ProspectsPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/security" element={<TotpPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
